"use client"

import { useEffect, useState } from "react"
import Image from "next/image"
import Link from "next/link"

import privacycloseicon from "@/assets/privacycloseicon.png"

export default function PrivacyAlert() {
  const [showDiv, setShowDiv] = useState(false)
  useEffect(() => {
    const accepted = localStorage.getItem("privacyAccepted")
    if (!accepted) {
      setShowDiv(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem("privacyAccepted", "true")
    setShowDiv(false)
  }
  return (
    showDiv && (
      <div className="relative mt-6 flex items-end justify-center gap-[25px] bg-[#fcfcfc] px-3 py-3 sm:mt-0 sm:items-center sm:px-0">
        <div className="text-[14px] text-[#1D2129]">
          SnapThePrice uses cookies to ensure you see the things we think you’ll
          love the most.{" "}
          <span className="cursor-pointer text-[#135BFF] underline">
            <Link href="/privacy#we-may-uses">Click here</Link>
          </span>{" "}
          to read our full policy
        </div>
        <div
          onClick={handleAccept}
          className="flex h-[33px] w-[170px] cursor-pointer items-center justify-center rounded-full bg-[#1D2129] text-[14px] text-white"
        >
          Accept
        </div>
        <div
          className="absolute top-4 right-4 cursor-pointer"
          onClick={handleAccept}
        >
          <Image
            src={privacycloseicon}
            alt="privacycloseicon"
            width={24}
            height={24}
          />
        </div>
      </div>
    )
  )
}
